// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "fba4fcda6820913c2d50" + ".chunk.js";
};